var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { KeycloakService } from '../../services/keycloak.service';
import { CommonService } from '../../services/common.service';
import { CedulaService } from '../../services/cedula.service';
import { Observable } from 'rxjs/Rx';
var CedulaFilterComponent = CedulaFilterComponent_1 = (function () {
    function CedulaFilterComponent(router, _http, _cedService, _comService) {
        this.router = router;
        this._http = _http;
        this._cedService = _cedService;
        this._comService = _comService;
        this.search = new EventEmitter(true);
        this.activateList = true;
        this.curPage = 0;
        this.visible = false;
        this.searchFilter = { fecha_desde: "", org_id: 0, caratula: "", usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10 };
        this.cantResul = 10;
        CedulaFilterComponent_1._observable = new Observable(function (observer) {
            return CedulaFilterComponent_1._observer = observer;
        }).share();
    }
    CedulaFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var date = new Date();
        this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        this._comService.findOrgByCedulas(KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.orgList = response;
        });
    };
    CedulaFilterComponent.prototype.onClickSearch = function () {
        this.searchFilter.page = 0;
        // console.log("-> q = " + JSON.stringify(this.searchFilter));
        // console.log("search q --> " + btoa(JSON.stringify(this.searchFilter)));
        this.router.navigate(['/cedula']);
        //this.search.emit(this.searchFilter);
        if (CedulaFilterComponent_1._observer) {
            CedulaFilterComponent_1._observer.next(this.searchFilter);
        }
    };
    CedulaFilterComponent.prototype.onChangeSelectOrg = function (newValue) {
        this.searchFilter.org_id = newValue;
    };
    CedulaFilterComponent.prototype.onChangeDate = function (select) {
        //this.searchFilter.fecha_hasta = this.searchFilter.fecha_desde;
    };
    CedulaFilterComponent.observable = function () {
        return CedulaFilterComponent_1._observable;
    };
    CedulaFilterComponent.prototype.onClickCancel = function () {
        this.ngOnInit();
        this.searchFilter.org_id = 0;
        this.searchFilter.numero = null;
        this.searchFilter.anio = null;
        this.searchFilter.cednumero = null;
        this.searchFilter.cedanio = null;
        this.searchFilter.caratula = "";
        this.hideErrorMsg();
        this.cantResul = 10;
        this.curPage = 0;
    };
    CedulaFilterComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    CedulaFilterComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    return CedulaFilterComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], CedulaFilterComponent.prototype, "search", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], CedulaFilterComponent.prototype, "visible", void 0);
CedulaFilterComponent = CedulaFilterComponent_1 = __decorate([
    Component({
        //selector: 'despacho-diario-component',
        moduleId: module.id,
        selector: 'cedula-filter',
        templateUrl: 'cedula-filter.component.html'
    }),
    __metadata("design:paramtypes", [Router,
        Http,
        CedulaService,
        CommonService])
], CedulaFilterComponent);
export { CedulaFilterComponent };
var CedulaFilterComponent_1;
//# sourceMappingURL=cedula-filter.component.js.map